<template>
    <div>
        Welcome {{ userId }}
    </div>
</template>

<script>
export default {
    name: 'Dashboard',
    setup() {
        
    },
    data() {
        return {
        }
    }
}
</script>
